import { continueLaterLocalization } from '@vwfs-its/sf-sac-frontend';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18n as i18nResources } from './resources/locales/common';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: i18nResources
    },
    lng: 'en',
    keySeparator: '.',
    interpolation: {
      escapeValue: false
    }
  });

const localization = continueLaterLocalization({
  locale: 'uk',
  brandName: { BRAND_NAME: process.env.REACT_APP_WEBSITE_BRAND }
});
// TODO: change au to the correct language once available
i18n.addResourceBundle('en', 'sf-sac', localization, true, true);

export default i18n;
